import { TransferFailed } from '../../pages';
import React from 'react';
import * as yup from 'yup';

const TransferFailedContainer = ({ closeModal }) => {
	return <TransferFailed closeModal={closeModal} />;
};

export default TransferFailedContainer;
